<template>
  <component :is="componentLoader" v-bind="generalProps"></component>
</template>

<script>
import "./helpers/importGlobalComponents";
import i18n from "./i18n";
import { filterTypes } from "./const/filterTypes";
import vuetify from "./plugins/vuetify";
import { locales } from "./const/locales";
import EnvProvider from "jvjr-docker-env";

export default {
  name: "App",
  i18n,
  vuetify,
  props: {
    top: {
      type: String,
      default: "1%"
    },
    left: {
      type: String,
      default: "1%"
    },
    zIndex: {
      type: String,
      default: () => "1"
    },
    background: {
      type: String,
      default: "transparent"
    },
    borderRadius: {
      type: String,
      default: "10px"
    },
    cdCliente: {
      type: Number,
      required: true,
      default: () => 7
    },
    token: {
      type: String,
      required: true,
      default: () =>
        "eyJhbGciOiJIUzUxMiIsInppcCI6IkRFRiJ9.eNokjUELwjAMhf-K5DxlzrkNj0PPwjzoNcwaAm1a1m4K4n831eP3vuS9N_inmAkOgA6JGAowsvDkxRlJGvfD-Xo5DZrPwhpsC2CJCWU0aqN9lK26OPrwYwqoKOgyHf1MFuPqhgvrRgEWhWak7EJa97k1cT7tmros1XtiUXn_P24i2yX3mVfQ5abt9ru6qurPFwAA__8.2EkhAHanSqwu0LRu8KuJHpHi_RKGEsxlzeVk2Avws7gcu5-52TTWCZJgFsStMMAbSjNfWNRmooN29psoEPnjXg"
    },
    filters: {
      type: String,
      default: () =>
        JSON.stringify([
          {
            identifier: "cdCorporativo",
            id: "cdCorporativo",
            description: "descCorporativo",
            labelName: "filters.corporate",
            path: "/corporativo"
          },
          {
            identifier: "cdRegional",
            id: "cdRegional",
            description: "descRegional",
            labelName: "filters.region",
            path: "/regional"
          },
          {
            identifier: "cdUnidade",
            id: "cdUnidade",
            description: "descUnidade",
            labelName: "filters.branch",
            path: "/unidade"
          },
          {
            identifier: "cdFazenda",
            id: "cdFazenda",
            description: "nomeFazenda",
            labelName: "filters.farm",
            path: "/geo_layer/fazenda"
          },
          {
            identifier: "cdZona",
            id: "cdZona",
            description: "cdZona",
            labelName: "filters.zone",
            path: "/geo_layer/zona"
          },
          {
            identifier: "cdTalhao",
            id: "cdTalhao",
            description: "descTalhao",
            labelName: "filters.field",
            path: "/geo_layer/talhao"
          },
          {
            identifier: "cdProcesso",
            id: "cdOperacao",
            description: "descOperacao",
            labelName: "filters.process",
            path: "/operacao/byState/E,S"
          },
          {
            identifier: "cdOperacao",
            id: "cdOperacao",
            description: "descOperacao",
            labelName: "filters.operation",
            path: "/operacao"
          }
        ])
    },
    /* Qual filtro irá renderizar */
    filterType: {
      type: String,
      default: () => "BI"
    },
    locale: {
      type: String,
      default: () => EnvProvider.value("I18N_LOCALE")
    },
    color: {
      type: String,
      default: () => "#03A9F4"
    },
    filterHierarchy: {
      type: String,
      default: () =>
        "null,cdCorporativo,cdRegional,cdUnidade,cdFazenda,cdZona,null,null"
    },
    parentSize: {
      type: Number,
      default: () => 1920
    },
    presetFilters: {
      type: String,
      default: () => JSON.stringify({})
    },
    filtersFieldsOrders: {
      type: String,
      default: () => JSON.stringify([])
    },
    dates: {
      type: String,
      default: () => JSON.stringify([])
    }
  },
  computed: {
    generalProps() {
      return Object.assign({}, this.$props);
    },
    componentLoader() {
      const findComponent = filterTypes.find(
        filter => filter.name === this.filterType
      );
      if (findComponent) {
        return findComponent.path;
      } else {
        throw new Error("Filter not found");
      }
    }
  },
  methods: {
    onInput(e) {
      console.log(e);
      this.$emit("onInput", e);
    },
    onClose() {
      this.$emit("onClose");
    },
    onSubValue(e) {
      this.$emit("subValue", e);
    }
  },
  provide() {
    return {
      onInput: this.onInput,
      onClose: this.onClose,
      onSubValue: this.onSubValue
    };
  },
  watch: {
    locale: {
      handler: function(value) {
        // Antes de setar o currentLocale, checar se existe na lista de locales
        if (locales.indexOf(value) > -1) {
          this.$i18n.locale = value;
        } else {
          this.$i18n.locale = EnvProvider.value("I18N_LOCALE");
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.v-application .primary {
  background-color: #1976d2 !important;
  border-color: #1976d2 !important;
}
.v-application .primary--text {
  color: #1976d2 !important;
  caret-color: #1976d2 !important;
}
@import url("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900");
@import url("https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css");
@import url("https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css");
</style>
